export default "__VITE_ASSET__CudyEL3p__"